import React from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { deliveryTypeTranslator } from "helpers/translators";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "contexts/AppContext/context";

const styles = {
  sectionTitle:
    "mt-[10px] w-full border-b-[1px] border-b-solid border-b-gd text-start text-gd font-[500] text-[19px] mb-[35px]",
  fields: {
    item: "mb-[30px] h-[50px] flex flex-col justify-center",
    longItem: "mb-[20px] flex flex-col justify-center",
    label: "font-[400] text-[13px] text-gd mb-[3px]",
    value: "",
    deliverId: "text-[13px]",
    redirectItem: "cursor-pointer hover:text-gd transition-all duration-200",
    redirectLabel: "ml-[25px]",
    redirectIcon: "text-gd",
  },
};

interface DeliveryDetailsInterface {
  order: any;
}

export default function DeliveryDetails({ order }: DeliveryDetailsInterface) {
  const navigate = useNavigate();
  const { appDispatch } = useAppContext();

  if (
    order?.delivery_id ||
    order?.delivery_type ||
    order?.delivery_url ||
    order?.prev_order_id
  )
    return (
      <div className="shadow-bs4 rounded-[10px] py-[17px] md:px-[30px] px-[20px] mt-8">
        <h1 className={styles.sectionTitle}>Datos de Envío</h1>
        <div className="grid grid-cols-3">
          {order?.delivery_id && (
            <div className={styles.fields.item}>
              <p className={styles.fields.label}>Albarán</p>
              <p className="text-[11px] mt-1">
                {order?.delivery_id || "Sin ID"}
              </p>
            </div>
          )}

          {order?.delivery_type && (
            <div className={styles.fields.item}>
              <p className={styles.fields.label}>Tipo de Envío</p>
              <p className={styles.fields.value}>
                {deliveryTypeTranslator(order?.delivery_type || "")}
              </p>
            </div>
          )}

          {order?.delivery_url && (
            <div
              className={`${styles.fields.item} ${styles.fields.redirectItem}`}
            >
              <a href={order?.delivery_url} target="_blank" rel="noreferrer">
                <p className={styles.fields.redirectLabel}>
                  Envío{" "}
                  <span>
                    <KeyboardArrowRightIcon
                      className={styles.fields.redirectIcon}
                    />
                  </span>
                </p>
              </a>
            </div>
          )}

          {order?.prev_order_id && (
            <div
              className={`${styles.fields.item} ${styles.fields.redirectItem}`}
              onClick={() => {
                // Clean current order
                appDispatch({
                  type: "setOrderOnView",
                  payload: null,
                });
                navigate(`/private/orders/view/${order?.prev_order_id}`);
              }}
            >
              <p className={styles.fields.redirectLabel}>
                P. Anterior{" "}
                <span>
                  <KeyboardArrowRightIcon
                    className={styles.fields.redirectIcon}
                  />
                </span>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  return null;
}
